// Admin → Assistant beta cohort: feature-flag gated access list for the
// Portfolio Assistant (env allowlist shown read-only alongside).
import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Bot, Save } from "lucide-react";

export const AssistantCohortCard = () => {
  const [cohort, setCohort] = useState("");
  const [envList, setEnvList] = useState([]);
  const [meta, setMeta] = useState(null);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");

  const load = useCallback(() => {
    api.get("/admin/assistant-cohort").then(({ data }) => {
      setCohort((data.cohort || []).join("\n"));
      setEnvList(data.env_allowlist || []);
      setMeta({ at: data.updated_at, by: data.updated_by });
    }).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true); setStatus("");
    try {
      const emails = cohort.split(/[\n,;]+/).map((e) => e.trim()).filter(Boolean);
      const { data } = await api.put("/admin/assistant-cohort", { emails });
      setStatus(`Saved — ${data.count} beta user(s) now have Assistant access.`);
      load();
    } catch (e) {
      setStatus(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="border" style={{ background: "var(--hoip-card)", borderColor: "var(--hoip-border)" }} data-testid="assistant-cohort-card">
      <div className="p-4 border-b flex items-center gap-2" style={{ borderColor: "var(--hoip-border)" }}>
        <Bot className="w-4 h-4 text-blue-400" />
        <span className="text-xs font-medium" style={{ color: "var(--hoip-text-secondary)" }}>
          Portfolio Assistant — beta cohort (feature flag)
        </span>
      </div>
      <div className="p-4 space-y-2">
        <div className="text-[10px]" style={{ color: "var(--hoip-text-tertiary)" }}>
          One email per line. These accounts get the Assistant (30 msgs/day, 10/min caps apply).
          Always-on env allowlist: {envList.join(", ") || "none"}.
        </div>
        <textarea value={cohort} onChange={(e) => setCohort(e.target.value)} rows={5}
          placeholder={"beta.user@example.com\nanother@example.com"}
          className="w-full bg-transparent border rounded-sm px-2 py-1.5 text-[11px] font-mono outline-none focus:border-blue-500"
          style={{ borderColor: "var(--hoip-border)", color: "var(--hoip-text-primary)" }}
          data-testid="assistant-cohort-input" />
        <div className="flex items-center gap-3">
          <button onClick={save} disabled={busy}
            className="inline-flex items-center gap-1.5 text-[10px] font-bold px-2.5 py-1.5 border rounded-sm hover:bg-[var(--hoip-hover)] transition-colors disabled:opacity-40"
            style={{ borderColor: "#3B82F655", color: "#3B82F6" }} data-testid="assistant-cohort-save-btn">
            <Save className="w-3 h-3" /> {busy ? "Saving…" : "Save cohort"}
          </button>
          {meta?.at && <span className="text-[9px]" style={{ color: "var(--hoip-text-tertiary)" }}>
            Last updated {meta.at.slice(0, 16).replace("T", " ")} UTC by {meta.by}</span>}
        </div>
        {status && <div className="text-[10px]" style={{ color: "#3B82F6" }} data-testid="assistant-cohort-status">{status}</div>}
      </div>
    </div>
  );
};
